import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../modal/Modal";
import { Button } from "@mantine/core";
export type TModalProps = {
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  title?: string;
  successButtonName?: string;
  dangerButtonName?: string;
  onSuccess?: () => void;
  onDanger: () => void;
  contentStyle?: string;
};

const ConfirmationModal: React.FC<TModalProps> = ({
  setModalVisible,
  modalVisible,
  title,
  successButtonName,
  dangerButtonName,
  onSuccess = () => {},
  onDanger = () => {},
  contentStyle,
}) => {
  const { t } = useTranslation();

  const onModalClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Modal
        compact
        center
        visible={modalVisible}
        style={"p-32"}
        onClose={onModalClose}
      >
        <div
          className={`text-center  ${contentStyle ? contentStyle : "mb-20"}`}
        >
          {title && <h1 className="f-w-700">{t(title)}</h1>}
        </div>
        <div className="row gap-30 row-column-phone-responsive">
          <Button color={"red"} mt={10} size="lg" fullWidth onClick={onSuccess}>
            {t(successButtonName || "confirm")}
          </Button>
          <Button
            mt={10}
            size="lg"
            className="modal-outlined-button"
            variant="outline"
            fullWidth
            onClick={onDanger}
          >
            {t(dangerButtonName || "cancel")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
